import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getVdpPfButtonSROnlyText } from 'site-modules/shared/utils/inventory/get-vdp-pf-button-text';
import { trackShowSilhouette } from 'site-modules/shared/utils/inventory/tracking';
import { TrackingConstant } from 'client/tracking/constant';
import { getNoVehicleImageToDisplay } from 'site-modules/shared/utils/get-no-vehicle-image-to-display';
import { Image } from 'site-modules/shared/components/image/image';
import { AspectRatioContainer } from 'site-modules/shared/components/aspect-ratio-container/aspect-ratio-container';
import { Photo360Indicator } from 'site-modules/shared/components/photo-360-indicator/photo-360-indicator';

import './inventory-hero-static-image.scss';

export function InventoryHeroStaticImage({
  isMobile = false,
  hasPhotos = false,
  hasPhoto360 = false,
  heroPhotoUrl,
  bodyType = '',
  vin,
  photoContainerAspectRatio,
  alt,
  hasError,
  setHasError,
  onClick,
  photoCount = 0,
}) {
  const onError = useCallback(() => {
    if (!hasError) {
      trackShowSilhouette(TrackingConstant.SHOW_SILHOUETTE_ERROR, vin, heroPhotoUrl);
      setHasError(true);
    }
  }, [hasError, heroPhotoUrl, setHasError, vin]);

  function getStaticImage(url, vehicleType, hasPhoto, hasImageError) {
    const errorImage = getNoVehicleImageToDisplay(vehicleType);

    return (
      <div className={classNames({ 'px-0_5': isMobile })}>
        <Image
          className={classNames('static-slide d-block bg-white rounded-12', { 'w-100': isMobile })}
          imageId={url}
          alt={alt}
          title={alt}
          key={url}
          errorImage={errorImage}
          source="static"
          onError={onError}
        />
        {hasPhoto && !hasImageError && (
          <button
            className="static-image-button bg-transparent w-100 h-100 border-0 p-0 pos-a top-0"
            onClick={onClick}
            data-tracking-id="open_legacy_photoflipper"
            aria-haspopup="dialog"
          >
            {hasPhoto360 && (
              <div className="pos-a top-0">
                <Photo360Indicator />
              </div>
            )}
            <span className="visually-hidden">{getVdpPfButtonSROnlyText(photoCount)}</span>
          </button>
        )}

        {(!hasPhoto || hasImageError) && (
          <div className="pos-a text-gray-darker fw-bold w-100 text-center" style={{ top: '83%' }}>
            Photos not available
          </div>
        )}
      </div>
    );
  }

  return (
    <AspectRatioContainer aspectRatio={photoContainerAspectRatio} className="static-image-wrapper">
      {getStaticImage(heroPhotoUrl, bodyType, hasPhotos, hasError)}
    </AspectRatioContainer>
  );
}

InventoryHeroStaticImage.propTypes = {
  isMobile: PropTypes.bool,
  hasPhotos: PropTypes.bool,
  hasPhoto360: PropTypes.bool,
  heroPhotoUrl: PropTypes.string.isRequired,
  bodyType: PropTypes.string,
  vin: PropTypes.string.isRequired,
  photoContainerAspectRatio: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  hasError: PropTypes.bool.isRequired,
  setHasError: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  photoCount: PropTypes.number,
};
